const ResearchLogs = {
    "Strange Solution": "You have identified the solution",
    "Archaic Glyphs": "You have translated the glyphs",
    "Ancient Stone": "You have identified the stone",
    "Dream Diary": "You have interpreted the dreams",
    "Cryptic Grimoire": "You have translated the grimoire",
    "Archive of Conduits": "You have identified the gateway",
    "Forbidden Tome": "You have translated the tome",
    "Ravenous Myconid": "You have classified a new species",
    "Dial of Ancients": "You have calculated the day of reckoning"
}

export default ResearchLogs